export default {
	appName: 'Hearts',
	platform: import.meta.env?.VITE_PLATFORM || null,
	version: '1.6.1',
	fullVersion: false,
	showErrors: false,
	showAppLinks: false,
	debugMode: false,
	facebookAdId: 158327870889130,
	showMoreGames: true,
	showAbout: true,
	showSendEmail: true,
	showRateGame: true,
	showSendFeedback: true,
	showRemoveAds: false,
	showIAPPage: false,
	TestMode: false,
	maxPingAllowed: 500,
	autoTestMode: false,
	removeAds: true,
	GAProperty: 'UA-43146845-1',
	ios: '6476223216',
	android: 'com.jdsoftwarellc.hearts',
	windows: '9NCRQB9643L7',
	email: 'hearts@jdsoftwarellc.com',
	emailSubject: 'Feedback',
	shareUrl: 'https://cardsjd.com/hearts/',
	shareTitle: 'Hearts',
	shareText: "Let's play Hearts",
	shareImage: './assets/Icons/Icon_512x512.png',
	storageName: 'hearts.userdata',
	gameStorageName: 'hearts.gameStorage',
	promptResetKey: '2026-09-09',
	webRateURL: 'https://www.facebook.com/profile.php?id=61555542160869',
	gamesUrl: 'https://cardsjd.com/config/moregames.json',
	colyseusServer: 'wss://heartsserver.jimmyinteractive.com',//'ws://localhost:2567',//ws://localhost:2567 //'ws://localhost:8080', //'ws://localhost:2567', //
	offsetStartdelay: 180,
	delayBetweenAds: 300,
	delayBetweenRewardedAds: 300,
	awayResetTime: 1200,
	overrides: {
		gameDistribution: {
			gameDistributionId: '0ed7109645a2436cb4787b363be44996',
		},
		android: {
			showRemoveAds: true,
			appId: 'ca-app-pub-2191584882036728~6078494005',
			interstitialAdId: 'ca-app-pub-2191584882036728/3203497775',
			rewardedAdId: 'ca-app-pub-2191584882036728/1887095418',
			appOpenAdId: 'ca-app-pub-2191584882036728/2530093249',
		},
		ios: {
			appId: 'ca-app-pub-2191584882036728~9818428468',
			interstitialAdId: 'ca-app-pub-2191584882036728/1831255099',
			rewardedAdId: 'ca-app-pub-2191584882036728/6951171098',
			appOpenAdId: 'ca-app-pub-2191584882036728/4325007751',
		},
		facebook: {
			showMoreGames: false,
			showSendEmail: false,
			showRateGame: false,
			showSendFeedback: false,
			interstitialAdId: '1388261732063000_1398759357679904',
			rewardedAdId: '1388261732063000_1398759531013220',
		},
		web: {
			adClient: 'ca-pub-2191584882036728',
			interstitialAdId: '5826340422',
		},
		windowsPWA: {
			adClient: 'ca-pub-2191584882036728',
			interstitialAdId: '5826340422',
		},
	},
};
